import { render, staticRenderFns } from "./ifmSubHeader.vue?vue&type=template&id=42bc93d1&scoped=true"
import script from "./ifmSubHeader.vue?vue&type=script&lang=js"
export * from "./ifmSubHeader.vue?vue&type=script&lang=js"
import style0 from "./ifmSubHeader.vue?vue&type=style&index=0&id=42bc93d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc93d1",
  null
  
)

export default component.exports